Ext.define('SA.model.TutorialNotice', {
    constructor(id) {
        this.id = id;
    },

    markViewed() {
        SA.model.Notices.acknowledge({id: this.id});
    }
});